import { useCallback } from 'react';
import { env } from '@/env';
import { useRegistration } from '@/context/RegistrationContext';

export const wregAppLink = (email: string, promoCode?: string | null): string => {
  const code = promoCode?.trim() || env.ACCESS_PILOT_PROMO_CODE;
  const emailParam = email ? `&email=${encodeURIComponent(email)}` : '';
  return `${env.BRANCH_URL}/?promoCode=${encodeURIComponent(code)}${emailParam}`;
};

export const useWregAppLink = (): (() => string) => {
  const { registrationData } = useRegistration();
  const email = registrationData.account.email;
  const promoCode = registrationData.promoCodeData?.code;
  return useCallback(() => wregAppLink(email, promoCode), [email, promoCode]);
};
